const selectProductAnalysisState = (state) =>
  state.cache.adebifyProductAnalysis;

const selectData = (state) => selectProductAnalysisState(state).data;

const selectGraphData = (state) => selectProductAnalysisState(state).graphData;

const selectMeta = (state) => selectProductAnalysisState(state).meta;

const selectIsLoading = (state) =>
  selectProductAnalysisState(state).isLoading;

const selectError = (state) => selectProductAnalysisState(state).error;

const selectParams = (state) => selectProductAnalysisState(state).params;

export {
  selectProductAnalysisState,
  selectData,
  selectGraphData,
  selectMeta,
  selectIsLoading,
  selectError,
  selectParams,
};

export default {
  selectProductAnalysisState,
  selectData,
  selectGraphData,
  selectMeta,
  selectIsLoading,
  selectError,
  selectParams,
};
